const rows = [
  { feature: "Earn rate", glow: "1x", radiance: "1.25x", luxe: "1.5x" },
  { feature: "Welcome bonus", glow: "100 pts", radiance: "200 pts", luxe: "300 pts" },
  { feature: "Birthday bonus", glow: "200 pts", radiance: "500 pts", luxe: "1000 pts" },
  { feature: "Anniversary bonus", glow: "100 pts", radiance: "250 pts", luxe: "500 pts" },
  { feature: "Tier qualification", glow: "₹0", radiance: "₹25,000+", luxe: "₹75,000+" },
  { feature: "Early launch access", glow: "—", radiance: "24h", luxe: "72h" },
  { feature: "Private VIP previews", glow: "—", radiance: "—", luxe: "✓" },
  { feature: "Festive hampers", glow: "—", radiance: "—", luxe: "✓" },
];

export default function LoyaltyBenefits() {
  return (
    <div className="max-w-[1300px] mx-auto px-6 lg:px-12 py-20" data-testid="page-benefits">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">THE BENEFITS</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-12">Compare<br /><em className="font-light">your tier.</em></h1>
      <div className="overflow-x-auto bg-white border border-black/10">
        <table className="data-table min-w-[800px]">
          <thead>
            <tr>
              <th className="!bg-black !text-white">FEATURE</th>
              <th className="!bg-black !text-white text-center">GLOW</th>
              <th className="!bg-black !text-white text-center">RADIANCE</th>
              <th className="!bg-black !text-white text-center">LUXE</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.feature}>
                <td className="font-medium">{r.feature}</td>
                <td className="text-center">{r.glow}</td>
                <td className="text-center">{r.radiance}</td>
                <td className="text-center font-semibold kazo-text-burgundy">{r.luxe}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
